import React from "react";
import { Container } from "react-bootstrap";
import { useParams } from "react-router-dom";
import PdfViewerCard from "../../PdfViewerCard";
import procedimientos from "./procedimientosRH";
import "../../incidentes.css";

const ProcedimientoRH = () => {
  const { slug } = useParams();
  const procedimiento = procedimientos.find((p) => p.slug === slug);

  if (!procedimiento) {
    return (
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Procedimiento no encontrado</h1>
        </div>
      </Container>
    );
  }

  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/${procedimiento.pdf}`;

  return (
    <Container fluid className="background-containerr">
      <div className="orgproc-header">
        <h1 className="orgproc-heading">{procedimiento.titulo}</h1>
      </div>
      {procedimiento.slug === "incidencias-rh" && (
        <div className="orgproc-card-actions">
          <a
            className="orgproc-card-btn"
            href="https://netjernetworksproduccion.odoo.com/es/vacaciones-rh"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ir al Sitio de Incidencias →
          </a>
        </div>
      )}
      <PdfViewerCard pdfUrl={pdfUrl} titulo={procedimiento.titulo} />
    </Container>
  );
};

export default ProcedimientoRH;